import Notifications from "../pages/Notifications";
import { useEffect, useState } from "react";
import { useIonModal } from "@ionic/react";
import { useUsersStore } from "../stores/users.store";
import { GuidedTour } from "../components/GuidedTour";
import { SetupBot } from "../pages/SetupBot";
import { usePrevious } from "../hooks/usePrevious";
import ConfirmationPage from "../pages/Confirmation";
import useOnlineStatus from "../hooks/useOnlineStatus";
import { useHistory } from "react-router";
import { useAnimationStore } from "../stores/animation.store";

interface User {
  notificationPreferences?: boolean;
  hasCompletedTour?: boolean;
  hasSetupBot?: boolean;
  quoCoin?: number;
}

interface PopupEffectProps {}

const PopupEffect: React.FC<PopupEffectProps> = () => {
  const [user, showTour, setShowTour] = useUsersStore(state => [
    state.user,
    state.showTour,
    state.setShowTour
  ]);
  const history = useHistory();
  const prevUser: any = usePrevious(user) as User | undefined;
  const [infoTitle, setInfoTitle] = useState("");

  const [presentNotifications, dismissNotifications] = useIonModal(
    Notifications,
    {
      onDismiss: () => dismissNotifications()
    }
  );
  const target = useAnimationStore(
    state => state.animations["botCongratsAnimation"]
  );

  const [presentPopup, dismissPopup] = useIonModal(ConfirmationPage, {
    onDismiss: () => {
      dismissPopup();
    },
    title: infoTitle,
    confirmText: "Let's Go!",
    lottieAnimation: target,
    contentHtml: `
      <div class="flex flex-col ion-text-center px-16 py-4 text-primary-30">
        <div class="pb-4 mx-auto">Use your QUO coin for lobby entries or to fast-track in-app features in single-player games.</div>
      </div>
    `,
    cssClass: "transparent-modal"
  });

  const [presentSetupBot, dismissSetupBot] = useIonModal(SetupBot, {
    mode: "simulation",
    navigateTo: (path: string) => history.push(path),
    onDismiss: () => dismissSetupBot()
  });

  useEffect(() => {
    if (user) {
      setTimeout(() => {
        if (!user.notificationPreferences) {
          presentNotifications();
        } else if (!user.hasCompletedTour) {
          setShowTour(true);
        } else if (!user.hasSetupBot) {
          presentSetupBot();
        }
      }, 1500);

      // QUO COIN ALERTS
      if (
        prevUser &&
        prevUser.hasSetupBot &&
        user &&
        (isNaN(prevUser.quoCoin) || prevUser.quoCoin === undefined) &&
        !isNaN(user.quoCoin ?? 0)
      ) {
        setInfoTitle(
          `Woot! You've just earned yourself ${user?.quoCoin?.toFixed(
            2
          )} QUO Coin!`
        );
        presentPopup();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, presentNotifications, presentPopup]);

  useOnlineStatus();
  return (
    <>{showTour && <GuidedTour isOpen={showTour} setIsOpen={setShowTour} />}</>
  );
};

export default PopupEffect;
